// extracted by mini-css-extract-plugin
module.exports = {"googleButtonWrapper":"_3uJve","googleLogoArea":"_1biN7","googleButtonText":"_3wq00"};
    if(module.hot) {
      // 1568284682182
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  